import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const usePaymentTerms = defineStore('payment-terms', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.paymentTerm_List,
    dto: 'PaymentTermDto',
    create: api.paymentTerm_Create,
    update: api.paymentTerm_Update,
    delete: api.paymentTerm_Delete,
    usage: api.paymentTerm_GetPaymentTermUsage,
    signalR: 'PaymentTermUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
